// Vendor
import { EventEmitter } from '@angular/core';
// Interfaces
import { CorrelationType } from 'ChartApp/ts/enums/fund-chart-common.enum';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../../../../ycharts/static/ts/features/pipes/index-of/index-of.pipe";
const _c0 = a0 => ({ active: a0 });
function CorrelationTypeTabsComponent_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 3)(1, "a", 4);
    i0.ɵɵlistener("click", function CorrelationTypeTabsComponent_li_2_Template_a_click_1_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.selectType($event, ctx_r1.CorrelationType.RATIO)); });
    i0.ɵɵtext(2, "Ratio");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMap(i0.ɵɵpureFunction1(2, _c0, ctx_r1.currentCorrelationType === ctx_r1.CorrelationType.RATIO));
} }
function CorrelationTypeTabsComponent_li_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 3)(1, "a", 4);
    i0.ɵɵlistener("click", function CorrelationTypeTabsComponent_li_4_Template_a_click_1_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.selectType($event, ctx_r1.CorrelationType.SPREAD)); });
    i0.ɵɵtext(2, "Spread");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMap(i0.ɵɵpureFunction1(2, _c0, ctx_r1.currentCorrelationType === ctx_r1.CorrelationType.SPREAD));
} }
function CorrelationTypeTabsComponent_li_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 3)(1, "a", 4);
    i0.ɵɵlistener("click", function CorrelationTypeTabsComponent_li_6_Template_a_click_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.selectType($event, ctx_r1.CorrelationType.CORRELATION)); });
    i0.ɵɵtext(2, "Correlation");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMap(i0.ɵɵpureFunction1(2, _c0, ctx_r1.currentCorrelationType === ctx_r1.CorrelationType.CORRELATION));
} }
/*
 * Correlation Type Tabs Component
 *
 * Required Attributes
 *
 * @Input correlationTypeOptions - correlation types available to be selected
 * @Input currentCorrelationType - Currently selected correlation type
 * @Output selectCorrelationType - Event emitted when type is selected
 */
export class CorrelationTypeTabsComponent {
    constructor() {
        this.selectCorrelationType = new EventEmitter();
        this.CorrelationType = CorrelationType;
    }
    selectType(e, type) {
        e.preventDefault();
        this.selectCorrelationType.emit(type);
    }
}
CorrelationTypeTabsComponent.ɵfac = function CorrelationTypeTabsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CorrelationTypeTabsComponent)(); };
CorrelationTypeTabsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CorrelationTypeTabsComponent, selectors: [["ycn-correlation-type-tabs"]], inputs: { correlationTypeOptions: "correlationTypeOptions", currentCorrelationType: "currentCorrelationType" }, outputs: { selectCorrelationType: "selectCorrelationType" }, standalone: false, decls: 8, vars: 12, consts: [[1, "tabs", "tabs-bordered"], ["id", "tabsModal", 1, "nav", "nav-tabs", "nav-width-equal"], ["class", "nav-item", 4, "ngIf"], [1, "nav-item"], ["href", "", 1, "nav-link", 3, "click"]], template: function CorrelationTypeTabsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "ul", 1);
        i0.ɵɵtemplate(2, CorrelationTypeTabsComponent_li_2_Template, 3, 4, "li", 2);
        i0.ɵɵpipe(3, "indexOf");
        i0.ɵɵtemplate(4, CorrelationTypeTabsComponent_li_4_Template, 3, 4, "li", 2);
        i0.ɵɵpipe(5, "indexOf");
        i0.ɵɵtemplate(6, CorrelationTypeTabsComponent_li_6_Template, 3, 4, "li", 2);
        i0.ɵɵpipe(7, "indexOf");
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind2(3, 3, ctx.correlationTypeOptions, ctx.CorrelationType.RATIO) > -1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind2(5, 6, ctx.correlationTypeOptions, ctx.CorrelationType.SPREAD) > -1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind2(7, 9, ctx.correlationTypeOptions, ctx.CorrelationType.CORRELATION) > -1);
    } }, dependencies: [i1.NgIf, i2.IndexOfPipe], encapsulation: 2 });
